import { render, staticRenderFns } from "./renderer.vue?vue&type=template&id=5c15464e&scoped=true"
import script from "./renderer.vue?vue&type=script&lang=js"
export * from "./renderer.vue?vue&type=script&lang=js"
import style0 from "./renderer.vue?vue&type=style&index=0&id=5c15464e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15464e",
  null
  
)

export default component.exports